module.exports = __webpack_public_path__ + "media/40.438ec296.mp3";